import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadJsService {
  constructor() {}

  public loadScriptloginJs() {      
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
          isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = [
        "../../assets/login.js",
      ];
      // console.log(document.getElementsByTagName('body')[0])
      for (var i = 0; i < dynamicScripts.length; i++) {
          let node = document.createElement('script');
          node.src = dynamicScripts [i];
          node.type = 'text/javascript';
          node.async = false;
          node.charset = 'utf-8';
          document.getElementsByTagName('body')[0].appendChild(node);
      }
    }
  }
  
  public loadScriptJs() {        
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
          isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = [
        // "../../assets/js/jquery.min.js",
        "../../assets/pike/js/pikeadmin.js",
        "../../assets/pike/js/modernizr.min.js",
        "../../assets/pike/js/moment.min.js",
        "../../assets/pike/js/popper.min.js",
        "../../assets/pike/js/bootstrap.min.js",
        "../../assets/pike/js/detect.js",
        "../../assets/pike/js/fastclick.js",
        "../../assets/pike/js/jquery.blockUI.js",
        "../../assets/pike/js/jquery.nicescroll.js",
        

      ];
      // console.log(document.getElementsByTagName('body')[0])
      for (var i = 0; i < dynamicScripts.length; i++) {
          let node = document.createElement('script');
          node.src = dynamicScripts [i];
          node.type = 'text/javascript';
          node.async = false;
          node.charset = 'utf-8';
          document.getElementsByTagName('body')[0].appendChild(node);
      }
    }
  }
}
